<script setup lang="ts">
import type { Crystallize } from "#shared/utils/crystallize-spec";

export type TagArticle = Pick<
  ArticleType | ArticleCard,
  "levels" | "subject" | "theme"
>;

const props = withDefaults(
  defineProps<
    {
      size?: "small" | "medium";
      article?: TagArticle;
      event?: EventCard;
    } & (
      | {
        article: TagArticle;
        event?: never;
      }
      | {
        article?: never;
        event: EventCard;
      }
    )
  >(),
  {
    article: undefined,
    event: undefined,
    size: "small",
  },
);

const EVENT_LABELS: Record<Crystallize.EventType, string> = {
  course: "kurs",
  themed: "fagkveld",
  webinar: "webinar",
  party: "fest",
  conferance: "konferanse",
};

const tags = computed(() => {
  if (props.article) {
    return getTagNamesFromValues(
      props.article.levels,
      props.article.subject,
      props.article.theme,
    );
  }

  if (props.event) {
    return [
      EVENT_LABELS[props.event.eventType],
      ...getTagNamesFromValues(props.event.levels),
    ];
  }

  return [];
});
</script>

<template>
  <div class="mt-2 flex flex-wrap items-center gap-(--gap) text-xs uppercase tracking-wider [--gap:0.4rem]">
    <span
      v-for="tag in tags"
      :key="tag"
      :class="size === 'small' ? 'text-xs' : 'text-lg'"
      class="after:pl-(--gap) after:content-['|'] last:after:pl-0 last:after:content-['']"
    >
      {{ tag }}
    </span>
  </div>
</template>
